import React, { useState, useRef } from 'react';
import jsonp from 'jsonp';
import toQueryString from 'to-querystring';
import css from './MailchimpSubscribe.module.scss';
import { fireAnalyticsEvent } from '../../analytics';

import { Button } from '@components/Button/Button';

const getAjaxUrl = url => url.replace('/post?', '/post-json?');

const CustomForm = ({ status, message, onValidated }) => {
  const email = useRef(null);
  // We use honeypot to prevent spam form submissions. For more detail:
  // https://stackoverflow.com/questions/36227376/better-honeypot-implementation-form-anti-spam
  const honeypot = useRef(null);

  const submit = e => {
    e.preventDefault();

    !honeypot.current.value &&
      email &&
      email.current.value.indexOf('@') > -1 &&
      onValidated({
        EMAIL: email.current.value,
      });
  };

  return (
    <div>
      <form onSubmit={e => submit(e)} className={css.form}>
        <input
          ref={email}
          id={'email_address'}
          type={'email'}
          name="email_address"
          placeholder="Your email..."
        />
        {/* Honeypot input */}
        <input
          className={css.honeypot}
          ref={honeypot}
          tabIndex={-1}
          type="text"
          name="company_name"
          placeholder="Company name"
          autoComplete="off"
        />
        <Button type="submit">{status === 'sending' ? 'Subscribing...' : 'Subscribe'}</Button>
      </form>
      {status ? (
        <div className={css.message}>
          {status === 'error' ? <div className={css.error}>{message}</div> : null}
          {status === 'success' ? <div className={css.success}>{message}</div> : null}
        </div>
      ) : null}
    </div>
  );
};

const MailchimpSubscribe = () => {
  const [status, setStatus] = useState('');
  const [message, setMessage] = useState('');

  const MailchimpURL =
    'https://us9.list-manage.com/subscribe/post?u=216d0e80594e1726eb9992b9b&id=2961acf514';
  const subscribe = data => {
    const params = toQueryString(data);
    let url = getAjaxUrl(MailchimpURL) + '&' + params;
    setStatus('sending');
    setMessage(null);

    //
    // Add additional parameter so we can add them to a specific interest group
    //
    // academy pages
    if (window.location.pathname.includes('/academy/')) {
      url = url + '&' + 'group[17910][4]=4';
    }
    // twoided podcast
    if (window.location.pathname.includes('/twosided/')) {
      url = url + '&' + 'group[17910][8]=8';
    }
    // balanced
    if (window.location.pathname.includes('/balanced/')) {
      url = url + '&' + 'group[17910][64]=64';
    }
    // dev blog
    if (window.location.pathname.includes('/developer-blog/')) {
      url = url + '&' + 'group[17910][1]=1';
    }

    // careers
    if (window.location.pathname.includes('/careers/')) {
      url =
        getAjaxUrl(
          'https://sharetribe.us9.list-manage.com/subscribe/post?u=216d0e80594e1726eb9992b9b&amp;id=0ed184c662&amp;f_id=00ed53e1f0'
        ) +
        '&' +
        params;
    }

    jsonp(
      url,
      {
        param: 'c',
      },
      (err, data) => {
        if (err) {
          setStatus('error');
          setMessage('There was an error. Please try again later.');
          console.error(err);
        } else if (data.result !== 'success') {
          setStatus('error');
          // Remove link tags from the error message -> add again in the future when the page is styled
          setMessage(data.msg?.split(' <a ')[0]?.replace(/&amp;/g, '&'));
          console.error(data.msg);
        } else {
          fireAnalyticsEvent('custom-newsletter-subscribed');
          setStatus('success');
          setMessage(data.msg);
        }
      }
    );
  };

  return (
    <CustomForm status={status} message={message} onValidated={formData => subscribe(formData)} />
  );
};

export default MailchimpSubscribe;
